<div class="barra-iconos-acciones">
  <app-icono-superior id="excel-download" [icono]="'icon-excel-download'" [isGrey]="true" [id]="'Excel-download'" (clickIcon)="botonAccionClicked($event)"></app-icono-superior>
  <app-icono-superior id="excel-upload" [icono]="'icon-excel-upload'" [isGrey]="true" [id]="'Excel-upload'" (clickIcon)="botonAccionClicked($event)"></app-icono-superior>
  <app-icono-superior id="pdf-download" [icono]="'icon-pdf-empty'" [isGrey]="true" [id]="'Pdf'" (clickIcon)="botonAccionClicked($event)"></app-icono-superior>
</div>
